import { createFileRoute } from '@tanstack/react-router'

import { userQueryOptions } from '@/queries/auth'

export const Route = createFileRoute(
  '/_authenticated/account/_accountDetails/personalInfo'
)({
  beforeLoad: () => ({
    title: 'Personal Info',
    breadCrumbTitle: 'Personal Info',
    subTitle: 'View and manage account information.',
  }),
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(userQueryOptions),
  onLeave: match =>
    match.context.accountManagementStore.getState().setEditingItem('none'),
})
